"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="hero" className="relative w-full bg-background text-foreground py-32 md:py-40 lg:py-48">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <h1 ref={headlineRef} className={`text-foreground font-bold text-4xl sm:text-5xl md:text-6xl leading-tight tracking-tight mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Modern Accounting for Your Business
        </h1>

        <p ref={paragraphRef} className={`text-foreground text-base sm:text-lg md:text-xl leading-relaxed mb-10 max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          Expert financial solutions tailored to help your business grow. From
          bookkeeping to strategic tax planning, we provide the clarity and
          confidence you need.
        </p>

        <div ref={ctaRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Button asChild size="lg" className="btn-primary text-base px-8 py-4 rounded-[var(--radius-full)] font-semibold shadow-soft hover:shadow-medium hover:-translate-y-0.5 active:translate-y-0 transition-all duration-[var(--duration-fast)] ease-out">
            <Link to="/ServicesPage">Explore Our Services</Link>
          </Button>
        </div>
      </div>
    </section>;
}